import { Link } from "react-router-dom";
import { useLang } from "../hooks/useLanguage";

const Privacy = () => {
  const { t } = useLang();
  return (
    <main className="bg-ivory text-[#202020] min-h-screen" data-testid="privacy-page">
      <div className="bg-[#141414] pt-36 pb-16 px-6 sm:px-10">
        <div className="max-w-4xl mx-auto">
          <p className="label-caps">{t.UI.privacyLabel}</p>
          <h1 className="mt-4 font-serif-lux font-light text-ivory text-[clamp(2.2rem,5vw,3.6rem)] leading-tight">
            {t.UI.privacyTitle}
          </h1>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 sm:px-10 py-16">
        <p className="text-sm text-smoke">{t.UI.privacyUpdated}</p>
        <div className="mt-10 space-y-10">
          {t.PRIVACY_SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="font-serif-lux text-2xl font-medium">{s.title}</h2>
              <p className="mt-3 text-smoke leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
        <Link to="/" className="btn-lux btn-lux-dark mt-14 inline-flex" data-testid="privacy-back-home">
          {t.UI.privacyBack}
        </Link>
      </div>
    </main>
  );
};

export default Privacy;
